<div class="data-management-page">
  <p-toast></p-toast>
  <msf-list-page-wrapper [leftSize]="'3'" [rightSize]="'9'">
    <!-- Left: Contexts sidebar -->
    <div left>
      <div class="sidebar">
        <div class="sidebar-header">
          <div class="title">{{ 'Contexts' | translate }}</div>
        </div>
        <div class="context-list">
          <div *ngFor="let c of dbContexts"
               class="context-item"
               [class.active]="c === selectedContext"
               (click)="selectedContext = c; onContextChange()">
            {{ c.displayName || c.name }}
          </div>
        </div>
      </div>
    </div>

    <!-- Right: Main area -->
    <div right>
      <div class="top-header">
        <h1>{{ 'Data Management' | translate }}</h1>
      </div>

      <div class="tables-list">
        <div class="table-card" *ngFor="let t of tables">
          <div class="title">{{ t.name }}</div>
          <div class="meta">
            <span>{{ 'Rows' | translate }}: {{ t.rowCount ?? '-' }}</span>
          </div>
          <div class="actions">
            <button pButton type="button" class="p-button-text" (click)="openStructure(t)" [disabled]="loadingStructure">
              <span *ngIf="loadingStructure" class="p-button-loading-icon pi pi-spin pi-spinner"></span>
              <span *ngIf="!loadingStructure">{{ 'Structure' | translate }}</span>
            </button>
            <button pButton type="button" class="p-button-text" (click)="openData(t)" [disabled]="loadingDataModal">
              <span *ngIf="loadingDataModal" class="p-button-loading-icon pi pi-spin pi-spinner"></span>
              <span *ngIf="!loadingDataModal">{{ 'Data' | translate }}</span>
            </button>
          </div>
        </div>
      </div>

    </div>
  </msf-list-page-wrapper>

  <p-dialog [(visible)]="showStructureModal" [modal]="true" [style]="{width:'680px'}" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="header">
      <span>{{ 'Structure' | translate }}: {{ structureTableName }}</span>
    </ng-template>
    <ng-template pTemplate="content">
      <div class="structure-content">
        <table class="structure-table">
          <thead>
          <tr>
            <th>{{ 'Column' | translate }}</th>
            <th>{{ 'Type' | translate }}</th>
            <th>{{ 'Primary Key' | translate }}</th>
            <th>{{ 'Foreign Key' | translate }}</th>
            <th>{{ 'Nullable' | translate }}</th>
            <th>{{ 'References' | translate }}</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let c of structureColumns">
            <td><strong>{{ c.name }}</strong></td>
            <td>{{ c.type }}</td>
            <td class="text-center">{{ c.isPrimaryKey ? '✓' : '-' }}</td>
            <td class="text-center">{{ c.isForeignKey ? '✓' : '-' }}</td>
            <td class="text-center">{{ c.isNullable ? '✓' : '-' }}</td>
            <td>{{ c.foreignKeyTableName || '-' }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <button pButton type="button" class="p-button-text" (click)="showStructureModal=false">{{ 'Close' | translate }}</button>
    </ng-template>
  </p-dialog>

  <p-dialog [(visible)]="showDataModal" [modal]="true" [style]="{width:'90vw', maxWidth: '1200px'}" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="header">
      <div class="data-header">
        <span class="data-title">{{ 'Table Data' | translate }}: {{ dataTableName }}</span>
        <span *ngIf="dataResult" class="data-count">({{ (dataResult.totalCount ?? 0) }} {{ 'Total records' | translate }})</span>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <div class="data-table-wrapper" *ngIf="dataResult as dr">
        <!-- Filter section -->
        <div class="filter-section">
          <div class="filter-input-group">
            <input 
              pInputText 
              type="text" 
              [(ngModel)]="filterSearchText"
              [placeholder]="'Search' | translate"
              (keyup.enter)="applyFilter()"
              class="filter-input" />
            <button pButton type="button" 
                    class="p-button-sm p-button-outlined" 
                    (click)="applyFilter()"
                    [disabled]="loadingData">
              {{ 'Apply' | translate }}
            </button>
            <button pButton type="button" 
                    class="p-button-sm p-button-text" 
                    (click)="clearFilter()"
                    [disabled]="loadingData">
              {{ 'Clear' | translate }}
            </button>
          </div>
        </div>

        <!-- Loading indicator -->
        <div *ngIf="loadingData" class="loading-container">
          <app-loading [loading]="true"></app-loading>
        </div>

        <!-- Data table -->
        <div class="data-table-container" *ngIf="!loadingData">
          <table class="data-table">
            <thead>
            <tr>
              <th *ngFor="let col of headerColumns">{{ col }}</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let row of dr.data; let i = index" [class.even]="i % 2 === 0">
              <td *ngFor="let col of rowKeys(row)" [ngClass]="{'copyable': isCopyableColumn(col)}">
                <span [title]="row[col]"
                      (click)="isCopyableColumn(col) ? copyCellValue(row[col]) : null"
                      [class.clickable]="isCopyableColumn(col)">
                  {{ formatCellValue(row[col]) }}
                </span>
              </td>
            </tr>
            <tr *ngIf="(dr.data?.length ?? 0) === 0">
              <td [attr.colspan]="headerColumns.length" class="no-data">{{ 'No data available' | translate }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        
        <div class="paginator">
          <div class="paginator-info">
            <span>{{ 'Page' | translate }} {{ dataPage }} {{ 'of' | translate }} {{ getTotalPages(dr.totalCount ?? 0) }}</span>
            <span class="records-info">({{ dr.totalCount ?? 0 }} {{ 'Total records' | translate }})</span>
          </div>
          <div class="paginator-controls">
            <button pButton type="button" 
                    (click)="fetchDataPage(dataPage-1)" 
                    [disabled]="dataPage<=1 || loadingData"
                    [pTooltip]="'Previous page' | translate">
              <i class="pi pi-chevron-left"></i>
            </button>
            <button pButton type="button" 
                    (click)="fetchDataPage(dataPage+1)" 
                    [disabled]="((dr?.totalCount || 0) <= dataPage*dataPageSize) || loadingData"
                    [pTooltip]="'Next page' | translate">
              <i class="pi pi-chevron-right"></i>
            </button>
          </div>
        </div>

        <!-- Export button -->
        <div class="export-section">
          <button pButton 
                  type="button" 
                  class="p-button-primary"
                  (click)="openExportModal()"
                  [disabled]="loadingData || exportLoading">
            <i class="pi pi-download"></i>
            <span>{{ 'Export' | translate }}</span>
          </button>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <button pButton type="button" class="p-button-text" (click)="showDataModal=false">{{ 'Close' | translate }}</button>
    </ng-template>
  </p-dialog>

  <!-- Export confirmation modal -->
  <p-dialog [(visible)]="showExportModal" [modal]="true" [style]="{width:'500px'}" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="header">
      <span>{{ 'Export Data' | translate }}</span>
    </ng-template>
    <ng-template pTemplate="content">
      <div class="export-modal-content">
        <p>{{ 'Export confirmation message' | translate: {tableName: dataTableName, maxRecords: 1000} }}</p>
        <p class="export-warning">{{ 'Maximum export limit' | translate }}</p>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <button pButton type="button" class="p-button-text" (click)="closeExportModal()">{{ 'Cancel' | translate }}</button>
      <button pButton type="button" class="p-button-primary" (click)="exportToCSV()" [disabled]="exportLoading">
        <span *ngIf="exportLoading" class="p-button-loading-icon pi pi-spin pi-spinner"></span>
        <span *ngIf="!exportLoading">{{ 'Export' | translate }}</span>
      </button>
    </ng-template>
  </p-dialog>
</div>


